var map = {
	"./account.svg": 200,
	"./arrow-minus.svg": 201,
	"./arrow-plus.svg": 202,
	"./check.svg": 203,
	"./close.svg": 204,
	"./email.svg": 205,
	"./facebook.svg": 206,
	"./instagram.svg": 207,
	"./mail.svg": 208,
	"./messenger.svg": 209,
	"./next.svg": 210,
	"./phone.svg": 211,
	"./prev.svg": 212,
	"./telegram.svg": 213,
	"./twitter.svg": 214,
	"./vk.svg": 215,
	"./whatsup.svg": 216,
	"./youtube.svg": 217,
	"./zen.svg": 218
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 705;